/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
const dependencies = [
  '$scope', 'uploadService', 'userValidation', 'notificationService', 'currentUserService'
];

const ManagerProfilePersonalDetailsController = function(
  $scope, uploadService, userValidation, notificationService, currentUserService
) {
  
  const vm = this;

  vm.flashErrors = {};

  vm.getOldPasswordErrors = userValidation.getPasswordErrors;
  vm.getNewPasswordErrors = userValidation.getPasswordErrors;

  vm.getEmailErrors = () => {
    return userValidation.getEmailErrors($scope.managerProfileLayoutCtrl.user && $scope.managerProfileLayoutCtrl.user.id);
  };

  $scope.$on('manager.profile.submit', function() {
    const changedUser = !_.isEqual($scope.managerProfileLayoutCtrl.user, currentUserService.getCurrentUser());
    if (changedUser) {
      return uploadService.saveWithFile($scope.managerProfileLayoutCtrl.user, 'avatar', function(user) {
        user.oldPassword = undefined;
        user.newPassword = undefined;
        $scope.managerProfileLayoutCtrl.updateUser(user);
        notificationService.notifySuccess('Your profile was successfully updated!');
      }, response => {
        return vm.flashErrors[response.data.field] = response.data.error;
      }, function(userSaveResponse) {
        vm.flashErrors[userSaveResponse.data.field] = userSaveResponse.data.error;
        return $scope.managerProfileLayoutCtrl.resetFormSubmitted();
      });
    } else {
      return $scope.managerProfileLayoutCtrl.resetFormSubmitted();
    }
  });

  return vm;
};

angular.module('public.client-manager.profile').controller('ManagerProfilePersonalDetailsController',
  dependencies.concat(ManagerProfilePersonalDetailsController));
